export const RS_CONTENT = {
  hero: {
    kicker: 'Para lojas físicas de varejo',
    title: 'Sua loja fecha o caixa e ninguém sabe se bateu com o estoque.',
    subtitle:
      'PDV completo, controle de estoque por código de barras e catálogo online integrado — tudo no mesmo sistema, sem planilha e sem depender da memória de quem está no caixa.',
    cta: 'Quero organizar minha loja',
    ctaMessage: 'Quero conhecer o sistema para lojas do 77Gestão',
    urgency: 'Cada dia sem controle real é venda que ninguém sabe se foi lucro ou prejuízo.',
  },

  statsStrip: [
    { number: '1 sistema', label: 'para caixa, estoque e catálogo online', icon: 'fa-solid fa-store' },
    { number: 'Tempo real', label: 'saldo de estoque após cada venda', icon: 'fa-solid fa-boxes-stacked' },
    { number: 'Automático', label: 'emissão de NFC-e no caixa', icon: 'fa-solid fa-receipt' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações na sua loja?',
    intro:
      'Toda loja física esbarra nos mesmos gargalos quando caixa, estoque e atendimento não estão no mesmo sistema.',
    items: [
      { icon: 'fa-solid fa-cash-register', text: 'Caixa fechado sem saber se o total bateu com o que realmente foi vendido no dia.' },
      { icon: 'fa-solid fa-box-open', text: 'Estoque desatualizado — só descobre que um produto acabou quando o cliente já está esperando no caixa.' },
      { icon: 'fa-solid fa-chart-simple', text: 'Não saber quais produtos mais vendem e quais só ocupam prateleira e capital parado.' },
      { icon: 'fa-solid fa-mobile-screen', text: 'Cliente pergunta preço pelo WhatsApp e alguém precisa tirar foto da prateleira para responder.' },
      { icon: 'fa-solid fa-user-slash', text: 'Cliente que compra sempre na loja, mas ninguém tem o histórico do que ele já levou antes.' },
    ],
  },

  midCta: {
    text: 'E se o caixa, o estoque e o catálogo da sua loja estivessem sempre batendo, no mesmo sistema?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema para lojas do 77Gestão',
  },

  solution: {
    title: 'Sua loja, do caixa à prateleira, em um único sistema.',
    intro:
      'O 77Gestão conecta o PDV da loja física ao estoque e a uma vitrine online, para que cada venda já atualize tudo automaticamente.',
    cards: [
      {
        icon: 'fa-solid fa-cash-register',
        title: 'PDV completo para o balcão',
        text: 'Abertura e fechamento de caixa, sangria e atalhos de teclado para agilizar o atendimento na hora da venda.',
      },
      {
        icon: 'fa-solid fa-barcode',
        title: 'Estoque por código de barras',
        text: 'Produtos com variações e código de barras, com o saldo atualizado automaticamente a cada venda no caixa.',
      },
      {
        icon: 'fa-solid fa-receipt',
        title: 'NFC-e emitida no caixa',
        text: 'Nota fiscal do consumidor emitida direto na venda do PDV, sem processo separado depois.',
      },
      {
        icon: 'fa-solid fa-shop',
        title: 'Catálogo online integrado',
        text: 'Vitrine digital com os mesmos produtos e preços da loja física, sempre sincronizada com o estoque real.',
      },
      {
        icon: 'fa-solid fa-address-book',
        title: 'Histórico de cliente',
        text: 'Saiba o que cada cliente já comprou antes, mesmo que ele só apareça de vez em quando na loja.',
      },
      {
        icon: 'fa-solid fa-chart-column',
        title: 'Relatório de produtos mais vendidos',
        text: 'Veja o que realmente vende e o que só ocupa espaço, para decidir compra e reposição com dado, não com achismo.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a loja para de fechar caixa no escuro',
    intro:
      'Uma loja de varejo que controlava caixa e estoque separadamente vivia com divergência no fechamento do dia e produto em falta na prateleira sem aviso.',
    stats: [
      { number: 'Tempo real', label: 'saldo de estoque após cada venda' },
      { number: '0', label: 'divergência entre caixa e estoque' },
      { number: '1 clique', label: 'para saber o produto mais vendido' },
    ],
    paragraphs: [
      'Depois de unificar caixa e estoque no mesmo sistema, cada venda no PDV passou a atualizar automaticamente o saldo do produto.',
      'O catálogo online, sincronizado com o estoque da loja física, passou a responder o cliente do WhatsApp sem precisar tirar foto de prateleira.',
    ],
    highlight: 'Resultado: caixa batendo todos os dias, estoque confiável e uma vitrine online sempre atualizada.',
    cta: 'Quero esse controle na minha loja',
    ctaMessage: 'Vi o resultado e quero organizar minha loja no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares de uma loja com controle de verdade',
    items: [
      {
        icon: 'fa-solid fa-link',
        title: 'Tudo conectado',
        text: 'Caixa, estoque e catálogo online no mesmo sistema — uma venda atualiza tudo automaticamente.',
      },
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade real',
        text: 'Saiba o que vende, o que falta e o que sobra, sem depender de contagem manual ou achismo.',
      },
      {
        icon: 'fa-solid fa-bolt',
        title: 'Atendimento mais rápido',
        text: 'PDV ágil no balcão e catálogo online para responder cliente fora do horário da loja.',
      },
    ],
  },

  differentials: {
    title: 'Por que lojas de varejo escolhem o 77Gestão',
    items: [
      { icon: 'fa-solid fa-store', text: 'Funciona para uma loja só ou para quem já tem mais de uma unidade com estoque próprio.' },
      { icon: 'fa-solid fa-shop', text: 'Catálogo online incluso, sem taxa de marketplace nem comissão sobre a venda.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: seu estoque e produtos já entram cadastrados no sistema.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e bem avaliado, para tirar dúvida no dia a dia do balcão.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Serve para qualquer tipo de loja, ou só para um segmento específico?',
        answer:
          'Serve para qualquer loja física de varejo que venda produtos com estoque — roupas, calçados, papelaria, pet shop, conveniência e outros segmentos.',
      },
      {
        question: 'O catálogo online processa pagamento pelo próprio site?',
        answer:
          'Não. O catálogo gera o pedido para você fechar via WhatsApp ou como uma proposta comercial dentro do sistema — não é um checkout de e-commerce com pagamento automático.',
      },
      {
        question: 'Preciso trocar meu leitor de código de barras?',
        answer:
          'Não necessariamente. O sistema trabalha com o código de barras já cadastrado no produto, e o leitor que você já usa normalmente continua funcionando.',
      },
      {
        question: 'A nota fiscal do consumidor (NFC-e) sai direto no caixa?',
        answer:
          'Sim. A NFC-e é emitida direto na venda do PDV, sem precisar de um processo separado depois do fechamento do caixa.',
      },
      {
        question: 'Tenho mais de uma loja. Dá para controlar o estoque de cada uma separadamente?',
        answer:
          'Sim. O sistema suporta múltiplos depósitos/locais de estoque, permitindo controlar o saldo de cada unidade separadamente.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de fechar caixa no escuro. Veja caixa, estoque e catálogo sempre batendo.',
    subtitle:
      'Agende uma demonstração e veja, na prática, como unificar o PDV, o estoque e o catálogo online da sua loja.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema para lojas do 77Gestão',
  },

  seo: {
    title: 'Sistema para Lojas — PDV, Estoque e Catálogo | 77Gestão',
    description:
      'Sistema para lojas de varejo: PDV completo, controle de estoque por código de barras e catálogo online integrado. Agende uma demonstração gratuita.',
  },
};
